<template>
	<!-- 店铺详情 -->
	<cube-page :title="type==1?'店主':'分销商'">
		<div slot="content">
			<div class="shopxq leopages">
				<van-form>
					<van-field v-model="entry.nickname" clearable label="名称" placeholder="名称" :name="type==1?'storename':'nickname' "
						disabled />
					<van-field v-model="entry.contacts" clearable label="联系人" placeholder="联系人" name="contacts"
						disabled />
					<van-field v-model="entry.mobile" clearable label="手机号码" placeholder="手机号码" name="mobile"
						disabled />
          <van-field v-model="entry.address" clearable label="地址" placeholder="地址" name="address" disabled />
          <div v-if="type==1">
            <van-field v-model="entry.notice" clearable rows="1" autosize label="店宣" type="textarea" name="dx"
              placeholder="请输入店宣" disabled />
            <van-radio-group v-model="entry.type" direction="horizontal" class="van-cell" disabled>
              <div class="van-cell__title van-field__label"><span>提现类型</span></div>
              <van-radio name="10">微信零钱</van-radio>
              <van-radio name="20">银行转账</van-radio>
            </van-radio-group>
            <div v-if="entry.type == 20">
              <van-field v-model="entry.user_name" clearable autosize label="真实姓名" name="user_name"
                disabled />
              <van-field v-model="entry.ID_card" clearable autosize label="身份证号" name="ID_card" disabled />
              <van-field v-model="entry.bank_card" clearable autosize label="银行卡号" name="bank_card"
                disabled />
            </div>
          </div>
					<div class="van-cell" style="align-items: center;">
						<div class="van-cell__title van-field__label"><span>头像</span></div>

						<van-image width="100" height="100" :src="entry.avatar" />
					</div>
					<div class="van-cell" style="align-items: center;">
						<div class="van-cell__title van-field__label"><span v-if="type==1">有效证件</span><span v-else>营业执照</span></div>

						<van-image width="100" height="100" :src="entry.idcard" />
					</div>
				</van-form>
				<van-goods-action v-if="entry.status != 'normal'">
					<van-goods-action-button type="warning" text="拒绝" @click="onShowJ('refuse')" />
					<van-goods-action-button type="primary" text="同意" @click="onShowJ('normal')"/>
				</van-goods-action>
			</div>
			<van-dialog v-model="show"
			:title="status=='refuse'?'拒绝操作':'同意操作'"
			 show-cancel-button @confirm="onConfirm">
				<div v-if="status=='refuse'">
					<van-field v-model="value" label="拒绝理由" placeholder="请输入拒绝的理由" />
				</div>
				<div v-else style="padding:20px;text-align: center;">
					确认要执行同意操作吗?
				</div>
			</van-dialog>
		</div>
	</cube-page>

</template>

<script>
	import {
		Toast,
		Dialog
	} from 'vant';
	import CubePage from '../../TP/cube-page.vue'
	import * as util from '@/utils/network'
	export default {
		components: {
			CubePage
		},
		data() {
			return {
				show: false,
				value: "",
				status: "",
        type: this.$route.query.type,
				entry: {
					storename: '智慧旅游-让旅游更实惠',
					mobile: '',
					notice: '本地直销无差价，全场5折起～',
					address: '',
					contacts: '',
					avatar: '',
					idcard: '',
					type: 10
				}

			}
		},
		methods: {
			onConfirm(){
				let that = this;
				if (that.$route.query.type == 2){
          var url = "/addons/litestore/api.distributor/examine"
        }else {
          var url = "/addons/litestore/api.store/examine"
        }

				let id = that.$route.query.id
				//这里直接调用网络接口
				util.post(url, {
						id: id,
						status:that.status,
						remarks:that.value
					},
					function(result) {
						Toast.success(result.msg);
						that.getData();
						// Toast.fail('失败文案');
					},
				);
			},
			onShowJ(val) {
				let that = this
				that.status =val;
				that.show=true
			},
			getData() {
				let that = this;
				//util.isToken
				if (that.$route.query.type == 1) {
					var url = "/addons/litestore/api.store/getStoreDetails"
				} else {
					var url = "/addons/litestore/api.distributor/getDistributorDetails"
				}

				let id = 1
				//这里直接调用网络接口
				util.get(url, {
						id: that.$route.query.id
					},
					function(result) {
						if (result.data != null) {
							that.entry = result.data
						}
					},
				);
			}
		},
		created() {
			this.getData()
		},
		watch: {
			"$store.state.gcfg"() {
				this.gcfg = this.$store.getters.getGcfg
			}
		},
	}
</script>
<style type="text/css" lang="less">
	.van-form {
		background-color: #FFFFFF;
		padding: 20px 0;

		.van-field--disabled .van-field__label,
		.van-field__control:disabled,
		.van-radio__label--disabled {
			color: #646566;
			-webkit-text-fill-color: #646566;
		}

		.van-radio__icon--disabled.van-radio__icon--checked .van-icon {
			color: #fff;
			background-color: #1989fa;
			border-color: #1989fa;
		}
	}
</style>
